const translations = {
  "en": {
    "Search your watchlist": "Search your watchlist"
  },
  "zh-tw": {
    "Search your watchlist": "搜尋你的追蹤清單"
  }
};

export default translations;
